import { lazy } from "react";
import { routeProps } from "Services/Share.props";
import RenderSubSection from "./RenderSubSections";

const HubsList = lazy(() => import("pages/Hubs/list"));
const HubsForm = lazy(() => import("pages/Hubs/HubForm"));
const BranchesList = lazy(() => import("pages/Branches/List"));
const BranchesForm = lazy(() => import("pages/Branches/BranchForm"));
const VendorsList = lazy(() => import("pages/Vendor/list"));
const VendorsForm = lazy(() => import("pages/Vendor/VendorForm"));
const NewFood = lazy(() => import("pages/Foods/Add"));
const FoodList = lazy(() => import("pages/Foods/List"));
const BundleFoodList = lazy(() => import("pages/Foods/Bundle/List"));
const BundleFoodAdd = lazy(() => import("pages/Foods/Bundle/Add"));
const ToppingList = lazy(() => import("pages/Topping/list"));
const ToppingForm = lazy(() => import("pages/Topping/form"));
const BatchToppingList = lazy(() => import("pages/BatchTopping/list"));
const BatchToppingForm = lazy(() => import("pages/BatchTopping/form"));
const AssignBatchList = lazy(() => import("pages/AssignBatchTopping/list"));
const AssignBatchToppingForm = lazy(
    () => import("pages/AssignBatchTopping/form")
);
const ConsumableGood = lazy(() => import("pages/Foods/Consumable/List"));
const ConsumableGoodAdd = lazy(() => import("pages/Foods/Consumable/Add"));

const hubList = {
    name: "لیست هاب‌ها",
    path: "/hub-list",
    group: "hub-list",
    exact: true,
    component: (props: routeProps) => <HubsList {...props} />,
};
const hubCreate = {
    name: "ثبت هاب جدید",
    path: "/new-hub",
    group: "new-hub",
    isHide: true,
    component: () => <HubsForm />,
};
const hubUpdate = {
    name: "به روز رسانی هاب",
    path: "/update-hub/:id",
    group: "update-hub",
    isHide: true,
    component: () => <HubsForm />,
};
const hubView = {
    name: "مشاهده هاب",
    path: "/view-hub/:id",
    group: "view-hub",
    isHide: true,
    component: () => <HubsForm />,
};
const batchList = {
    name: "لیست دسته تاپینگ ها",
    path: "/batch-list",
    group: "batch-list",
    exact: true,
    component: (props: routeProps) => <BatchToppingList {...props} />,
};
const batchCreate = {
    name: "افزودن دسته تاپینگ",
    path: "/new-batch",
    group: "create-batch",
    isHide: true,
    component: () => <BatchToppingForm />,
};
const batchUpdate = {
    name: "به روز رسانی دسته تاپینگ",
    path: "/update-batch/:id",
    group: "update-batch",
    isHide: true,
    component: () => <BatchToppingForm />,
};
const batchView = {
    path: "/view-batch/:id",
    group: "view-batch",
    isHide: true,
    name: "مشاهده دسته تاپینگ",
    component: () => <BatchToppingForm />,
};
const AssignBatchToppingList = {
    name: "لیست انتخاب دسته تاپینگ برای غذا",
    path: "/assign-list",
    group: "assign-list",
    exact: true,
    component: (props: routeProps) => <AssignBatchList {...props} />,
};
const AssignBatchToppingCreate = {
    name: "افزودن دسته تاپینگ برای غذا",
    path: "/new-assign",
    group: "new-assign",
    isHide: true,
    component: () => <AssignBatchToppingForm />,
};
const AssignBatchToppingUpdate = {
    name: "به روز رسانی دسته تاپینگ برای غذا",
    path: "/update-assign/:id",
    group: "update-assign",
    isHide: true,
    component: () => <AssignBatchToppingForm />,
};
const AssignBatchToppingView = {
    path: "/view-assign/:id",
    group: "view-assign",
    isHide: true,
    name: "مشاهده دسته تاپینگ برای غذا",
    component: () => <AssignBatchToppingForm />,
};
const toppingList = {
    name: "لیست تاپینگ‌ها",
    path: "/topping-list",
    group: "topping-list",
    exact: true,
    component: (props: routeProps) => <ToppingList {...props} />,
};
const toppingCreate = {
    name: "ثبت تاپینگ جدید",
    path: "/new-topping",
    group: "new-topping",
    isHide: true,
    component: () => <ToppingForm />,
};
const toppingUpdate = {
    name: "به روز رسانی تاپینگ",
    path: "/update-topping/:id",
    group: "update-topping",
    isHide: true,
    component: () => <ToppingForm />,
};
const toppingView = {
    name: "مشاهده تاپینگ",
    path: "/view-topping/:id",
    group: "view-topping",
    isHide: true,
    component: () => <ToppingForm />,
};

const branchList = {
    name: "لیست شعبه‌ها",
    path: "/branch-list",
    group: "branch-list",
    exact: true,
    component: (props: routeProps) => <BranchesList {...props} />,
};
const branchCreate = {
    name: "ثبت شعبه جدید",
    path: "/new-branch",
    group: "new-branch",
    isHide: true,
    component: () => <BranchesForm />,
};
const branchUpdate = {
    name: "به روز رسانی شعبه",
    path: "/update-branch/:id",
    group: "update-branch",
    isHide: true,
    component: () => <BranchesForm />,
};
const branchView = {
    name: "مشاهده شعبه",
    path: "/view-branch/:id",
    isHide: true,
    component: () => <BranchesForm />,
};
const vendorList = {
    name: "لیست وندورها",
    path: "/vendor-list",
    group: "vendor-list",
    exact: true,
    component: (props: routeProps) => <VendorsList {...props} />,
};
const vendorCreate = {
    name: "ثبت وندور جدید",
    path: "/new-vendor",
    group: "new-vendor",
    isHide: true,
    component: () => <VendorsForm />,
};
const vendorUpdate = {
    name: "به روز رسانی وندور",
    path: "/update-vendor/:id",
    group: "update-vendor",
    isHide: true,
    component: () => <VendorsForm />,
};
const vendorView = {
    name: "مشاهده وندور",
    path: "/view-vendor/:id",
    group: "view-vendor",
    isHide: true,
    component: () => <VendorsForm />,
};
const foodList = {
    name: "لیست غذاها",
    path: "/food-list",
    group: "food-list",
    exact: true,
    component: (props: routeProps) => <FoodList {...props} />,
};
const foodCreate = {
    name: "ثبت غذای جدید",
    path: "/new-food",
    group: "new-food",
    isHide: true,
    component: () => <NewFood />,
};
const foodUpdate = {
    name: "به روز رسانی غذا",
    path: "/update-food/:id",
    group: "update-food",
    isHide: true,
    component: () => <NewFood />,
};
const foodView = {
    name: "مشاهده غذا",
    path: "/view-food/:id",
    group: "view-food",
    isHide: true,
    component: () => <NewFood />,
};
const bundleList = {
    name: "لیست غذای گروهی",
    path: "/bundle-list",
    group: "bundle-list",
    exact: true,
    component: (props: routeProps) => <BundleFoodList {...props} />,
};
const bundleCreate = {
    name: "افزودن غذای گروهی",
    path: "/new-bundle",
    group: "new-bundle",
    isHide: true,
    component: () => <BundleFoodAdd />,
};
const bundleUpdate = {
    name: "به روز رسانی غذای گروهی",
    path: "/update-bundle/:id",
    group: "update-bundle",
    isHide: true,
    component: () => <BundleFoodAdd />,
};
const bundleView = {
    name: "مشاهده غذای گروهی",
    path: "/view-bundle/:id",
    group: "view-bundle",
    isHide: true,
    component: () => <BundleFoodAdd />,
};
const consumableGoodList = {
    name: "لیست اقلام مصرفی",
    path: "/consumable-good-list",
    group: "consumable-good-list",
    exact: true,
    component: (props: routeProps) => <ConsumableGood {...props} />,
};
const consumableGoodCreate = {
    name: "افزودن اقلام مصرفی",
    path: "/new-consumable-good",
    group: "new-consumable-good",
    isHide: true,
    component: () => <ConsumableGoodAdd />,
};
const consumableGoodUpdate = {
    name: "به روز رسانی اقلام مصرفی",
    path: "/update-consumable-good/:id",
    group: "update-consumable-good",
    isHide: true,
    component: () => <ConsumableGoodAdd />,
};
const consumableGoodView = {
    name: "مشاهده اقلام مصرفی",
    path: "/view-consumable-good/:id",
    group: "view-consumable-good",
    isHide: true,
    component: () => <ConsumableGoodAdd />,
};

const subSections = {
    hub: {
        list: { ...hubList },
        create: { ...hubCreate },
        update: { ...hubUpdate },
        view: { ...hubView },
    },
    vendor: {
        list: { ...vendorList },
        create: { ...vendorCreate },
        update: { ...vendorUpdate },
        view: { ...vendorView },
    },
    branch: {
        list: { ...branchList },
        create: { ...branchCreate },
        update: { ...branchUpdate },
        view: { ...branchView },
    },
    bundle: {
        list: { ...bundleList },
        create: { ...bundleCreate },
        update: { ...bundleUpdate },
        view: { ...bundleView },
    },
    food: {
        list: { ...foodList },
        create: { ...foodCreate },
        update: { ...foodUpdate },
        view: { ...foodView },
    },
    consumableGood: {
        list: { ...consumableGoodList },
        create: { ...consumableGoodCreate },
        update: { ...consumableGoodUpdate },
        view: { ...consumableGoodView },
    },
    topping: {
        list: { ...toppingList },
        create: { ...toppingCreate },
        update: { ...toppingUpdate },
        view: { ...toppingView },
    },
    batch: {
        list: { ...batchList },
        create: { ...batchCreate },
        update: { ...batchUpdate },
        view: { ...batchView },
    },

    assignBatchTopping: {
        list: { ...AssignBatchToppingList },
        create: { ...AssignBatchToppingCreate },
        update: { ...AssignBatchToppingUpdate },
        view: { ...AssignBatchToppingView },
    },
};

const RegistrySection = {
    title: "عملیات ثبت",
    key: "registry",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};

export default RegistrySection;
